import GraphViewer from './components/GraphViewer'
import * as Icons from './components/icons'
import { IndigoRoot } from './components/IndigoRoot'
import { RecipeViewer } from './components/graph/RecipeViewer'
import * as Controls from './components/controls'

const Indigo = { IndigoRoot, RecipeViewer, Controls }

export { Indigo, GraphViewer, Icons }
